import { Link } from 'react-router-dom'
import { CalculatorLink } from './CalculatorLink'
import { RelatedArticles } from './RelatedArticles'

interface ArticleLayoutProps {
  title: string
  publishedAt: string
  slug?: string
  children: React.ReactNode
}

export function ArticleLayout({ title, publishedAt, slug, children }: ArticleLayoutProps) {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      {/* Breadcrumb */}
      <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-6">
        <Link to="/" className="hover:text-foreground transition-colors">RatyGo</Link>
        <span>/</span>
        <Link to="/blog" className="hover:text-foreground transition-colors">Blog</Link>
        <span>/</span>
        <span className="text-foreground truncate">{title}</span>
      </nav>

      <article>
        <header className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-foreground leading-tight mb-3">
            {title}
          </h1>
          <time className="text-sm text-muted-foreground" dateTime={publishedAt}>
            {new Date(publishedAt).toLocaleDateString('pl-PL', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </time>
        </header>

        <div className="space-y-6 text-foreground leading-relaxed text-[1.05rem]">
          {children}
        </div>
      </article>

      {/* Related articles for topical authority / internal linking */}
      {slug && <RelatedArticles currentSlug={slug} />}

      {/* Bottom CTA */}
      <div className="mt-12 p-6 rounded-2xl bg-gradient-to-br from-indigo-50 to-violet-50 border border-indigo-100">
        <h2 className="text-lg font-bold text-foreground mb-2">
          Oblicz swoją ratę kredytu
        </h2>
        <p className="text-sm text-muted-foreground mb-4">
          Skorzystaj z interaktywnego kalkulatora RatyGo, aby sprawdzić jak wyglądałby Twój kredyt hipoteczny.
        </p>
        <CalculatorLink>
          Otwórz kalkulator
        </CalculatorLink>
      </div>

      {/* Back to blog */}
      <div className="mt-8">
        <Link
          to="/blog"
          className="text-sm text-muted-foreground hover:text-foreground transition-colors inline-flex items-center gap-1.5"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
          </svg>
          Wróć do wszystkich artykułów
        </Link>
      </div>
    </div>
  )
}
